export const EVENT_NEAR_RADIUS_MILES = [10, 25, 50, 100] as const
export type EventNearRadiusMiles = (typeof EVENT_NEAR_RADIUS_MILES)[number]
export const DEFAULT_EVENT_NEAR_RADIUS_MILES: EventNearRadiusMiles = 50

/** Higher fetch limit when proximity search is active so map pins aren't capped at list page size. */
export const EVENT_NEAR_FETCH_LIMIT = 100

export function milesToMeters(miles: number) {
  return miles * 1609.344
}

export function parseEventNearRadiusMiles(value: string | null): EventNearRadiusMiles {
  const n = Number(value)
  if ((EVENT_NEAR_RADIUS_MILES as readonly number[]).includes(n)) {
    return n as EventNearRadiusMiles
  }
  return DEFAULT_EVENT_NEAR_RADIUS_MILES
}

export function isUsZipCode(value: string): boolean {
  return /^\d{5}(-\d{4})?$/.test(value.trim())
}
